import styled from '@emotion/styled';
import { Magnetic } from "../../../styles";
export const StyledButton = styled('button') `
	display: flex;
	justify-content: center;
	align-items: center;
	position: relative;
	border: none;
	cursor: ${Magnetic.actionableCursor};
	border-radius: ${Magnetic.baseBorderRadius};
	height: ${Magnetic.spacer40};
	width: ${Magnetic.formControlCoreWidth};
	background: ${(props) => props.buttonBackgroundColor};
	color: ${(props) => props.buttonTextColor};
`;
export const StyledIcon = styled('span') `
	padding: 0 ${Magnetic.spacer08} ${Magnetic.spacer04} 0;
	color: ${(props) => props.color};
	font-size: ${(props) => props.fontSize};
`;
//# sourceMappingURL=WhiteLabelMobileButton.style.js.map